import { router } from '@inertiajs/vue3'
import { processTemplateLiterals } from '@/Composables/processTemplateLiterals'
import { useEventBusStore } from '@/Pinia/EventBus'

/**
 * Navigates to a processed route. Optionally emits an event via EventBus on navigation success.
 *
 * @param routeTemplate - A template literal (string or number) to process for the route.
 * @param model - A record of model properties to replace template placeholders.
 * @param eventToEmit - (Optional) The name of the event to emit after navigation succeeds.
 */
export function navigateToRoute(
    routeTemplate: string | number,
    model: Record<string, any>, // eslint-disable-line @typescript-eslint/no-explicit-any
    eventToEmit?: string,
): void {
    const EventBus = useEventBusStore()
    let route = processTemplateLiterals(routeTemplate, model)

    if (route === null) {
        console.error('Processed route is null. Navigation aborted.')
        return
    }

    if (typeof route === 'number') {
        route = route.toString()
    }

    const currentUrl = window.location.pathname + window.location.search
    if (currentUrl === route) {
        if (eventToEmit) {
            EventBus.emit(eventToEmit)
        }
        return
    }

    if (eventToEmit) {
        router.visit(route, {
            onSuccess: () => {
                EventBus.emit(eventToEmit)
            },
        })
    } else {
        router.visit(route)
    }
}
